import React, { useState, useRef } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import jsPDF from "jspdf";
import axios from "axios"; // Import axios for API calls

const EditableResumeTemplate = () => {
  const [cvData, setResume] = useState({
    name: "Shubham Mukati",
    title: "Software Engineer",
    phoneNumber: "7247643764",
    email: "shubham.mukati@parkhya.net",
    location: "Indore, India",
    summary: "Experienced software engineer with a passion for developing innovative applications.",
    experience: [
      {
        title: "Software Developer",
        company: "Parkhya Solution Pvt. Ltd.",
        startDate: "2024-12-16",
        endDate: "till now",
        description: "Worked on building scalable web applications using React and Node.js."
      }
    ],
    education: [
      {
        degree: "B.Tech (CSE)",
        institution: "SAGE University, Indore",
        startDate: "2019",
        endDate: "2023"
      }
    ],
    projects: [
      {
        title: "Balloon Decoration",
        description: "A Website show the Event Management & Decoration ideas and images",
        technologies: ["HTML", "CSS", "JavaScript"],
        link: "https://aaiji-decoration.com"
      }
    ],
    skills: ["JavaScript", "React", "Node.js"],
    extraFields: {
      github: "https://github.com/shubhammukati",
      linkedin: "https://linkedin.com/in/shubhammukati"
    }
  });

  const handleChange = (e, field) => {
    setResume({ ...cvData, [field]: e.target.value });
  };

  const handleNestedChange = (e, field, index, subField) => {
    const updatedField = [...cvData[field]];
    updatedField[index] = {
      ...updatedField[index],
      [subField]: e.target.value,
    };
    setResume({ ...cvData, [field]: updatedField });
  };

  const addEntry = (field, newEntry) => {
    setResume({ ...cvData, [field]: [...cvData[field], newEntry] });
  };

  const removeEntry = (field, index) => {
    const updatedField = cvData[field].filter((_, i) => i !== index);
    setResume({ ...cvData, [field]: updatedField });
  };

  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setResume({ ...cvData, photo: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };

  const componentRef = useRef();

  const handleSaveAsPDF = () => {
    const pdf = new jsPDF();
    let y = 10; // Initial Y position

    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(16);
    pdf.text(cvData.name, 10, y);
    y += 8;

    pdf.setFontSize(14);
    pdf.text(cvData.title, 10, y);
    y += 10;

    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(12);
    pdf.text("Summary:", 10, y);
    y += 6;
    pdf.text(cvData.summary, 10, y, { maxWidth: 180 });
    y += 10;

    pdf.text("Phone: " + cvData.phoneNumber, 10, y);
    y += 6;
    pdf.text("Email: " + cvData.email, 10, y);
    y += 6;
    pdf.text("Location: " + cvData.location, 10, y);
    y += 10;

    // Experience
    pdf.setFont("helvetica", "bold");
    pdf.text("Experience", 10, y);
    y += 6;
    pdf.setFont("helvetica", "normal");
    cvData.experience.forEach((exp) => {
      pdf.text(`${exp.title} at ${exp.company}`, 10, y);
      y += 6;
      pdf.text(`${exp.startDate} - ${exp.endDate}`, 10, y);
      y += 6;
      pdf.text(exp.description, 10, y, { maxWidth: 180 });
      y += 10;
    });

    // Education
    pdf.setFont("helvetica", "bold");
    pdf.text("Education", 10, y);
    y += 6;
    pdf.setFont("helvetica", "normal");
    cvData.education.forEach((edu) => {
      pdf.text(`${edu.degree} at ${edu.institution}`, 10, y);
      y += 6;
      pdf.text(`${edu.startDate} - ${edu.endDate}`, 10, y);
      y += 10;
    });

    // Projects
    pdf.setFont("helvetica", "bold");
    pdf.text("Projects", 10, y);
    y += 6;
    pdf.setFont("helvetica", "normal");
    cvData.projects.forEach((proj) => {
      pdf.text(`${proj.title}`, 10, y);
      y += 6;
      pdf.text(proj.description, 10, y, { maxWidth: 180 });
      y += 6;
      pdf.text(`Technologies: ${proj.technologies.join(", ")}`, 10, y);
      y += 6;
      pdf.text(`Link: ${proj.link}`, 10, y);
      y += 10;
    });

    // Skills
    pdf.setFont("helvetica", "bold");
    pdf.text("Skills", 10, y);
    y += 6;
    pdf.setFont("helvetica", "normal");
    cvData.skills.forEach((skill) => {
      pdf.text(`• ${skill}`, 10, y);
      y += 6;
    });

    // Extra Fields
    y += 6;
    pdf.setFont("helvetica", "bold");
    pdf.text("Extra Fields", 10, y);
    y += 6;
    pdf.setFont("helvetica", "normal");
    pdf.text(`GitHub: ${cvData.extraFields.github}`, 10, y);
    y += 6;
    pdf.text(`LinkedIn: ${cvData.extraFields.linkedin}`, 10, y);
    y += 10;

    pdf.save("cvData.pdf");
  };

  // Save draft API request
  const handleSaveDraft = async () => {
    try {
      const response = await axios.post(
        "https://ai-powered-cv-maker-api.vercel.app/api/draft/save-draft/67ab39cb0000f2df3bd0aa01",
        { cvData }, // Wrapped inside an object to match API format
        { headers: { "Content-Type": "application/json" } }
      );
      console.log("Response", response);

      if (response.status === 200) {
        alert("Draft saved successfully!");
      } else {
        alert("Failed to save draft.");
      }
    } catch (error) {
      console.error("Error saving draft:", error);
      alert(
        `An error occurred while saving the draft: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  return (
    <Container className="mt-4">
      <Row>
        {/* Left Column: Edit Section */}
        <Col xs={12} sm={12} md={6}>
          <Card>
            <Card.Body>
              <h4>Edit Resume</h4>

              {/* Photo Upload */}
              <Form.Group className="mb-3">
                <Form.Label>Upload Photo</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={handlePhotoUpload}
                />
              </Form.Group>

              {/* Basic Info */}
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.name}
                  onChange={(e) => handleChange(e, "name")}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.title}
                  onChange={(e) => handleChange(e, "title")}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Summary</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={cvData.summary}
                  onChange={(e) => handleChange(e, "summary")}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.phoneNumber}
                  onChange={(e) => handleChange(e, "phoneNumber")}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.email}
                  onChange={(e) => handleChange(e, "email")}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Location</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.location}
                  onChange={(e) => handleChange(e, "location")}
                />
              </Form.Group>

              {/* Experience */}
              <h5>Experience</h5>
              {cvData.experience.map((exp, index) => (
                <div key={index} className="mb-3">
                  <Form.Group>
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.title}
                      onChange={(e) =>
                        handleNestedChange(e, "experience", index, "title")
                      }
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Company</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.company}
                      onChange={(e) =>
                        handleNestedChange(e, "experience", index, "company")
                      }
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.startDate}
                      onChange={(e) =>
                        handleNestedChange(e, "experience", index, "startDate")
                      }
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.endDate}
                      onChange={(e) =>
                        handleNestedChange(e, "experience", index, "endDate")
                      }
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={exp.description}
                      onChange={(e) =>
                        handleNestedChange(e, "experience", index, "description")
                      }
                    />
                  </Form.Group>
                  <Button
                    variant="danger"
                    onClick={() => removeEntry("experience", index)}
                  >
                    Remove Experience
                  </Button>
                </div>
              ))}
              <Button
                onClick={() =>
                  addEntry("experience", {
                    title: "",
                    company: "",
                    startDate: "",
                    endDate: "",
                    description: "",
                  })
                }
              >
                Add Experience
              </Button>

              {/* Education */}
              <h5 className="mt-3">Education</h5>
              {cvData.education.map((edu, index) => (
                <div key={index} className="mb-3">
                  <Form.Group>
                    <Form.Label>Degree</Form.Label>
                    <Form.Control
                      type="text"
                      value={edu.degree}
                      onChange={(e) =>
                        handleNestedChange(e, "education", index, "degree")
                      }
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Institution</Form.Label>
                    <Form.Control
                      type="text"
                      value={edu.institution}
                      onChange={(e) =>
                        handleNestedChange(e, "education", index, "institution")
                      }
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={edu.startDate}
                      onChange={(e) =>
                        handleNestedChange(e, "education", index, "startDate")
                      }
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={edu.endDate}
                      onChange={(e) =>
                        handleNestedChange(e, "education", index, "endDate")
                      }
                    />
                  </Form.Group>
                  <Button
                    variant="danger"
                    onClick={() => removeEntry("education", index)}
                  >
                    Remove Education
                  </Button>
                </div>
              ))}
              <Button
                onClick={() =>
                  addEntry("education", {
                    degree: "",
                    institution: "",
                    startDate: "",
                    endDate: "",
                  })
                }
              >
                Add Education
              </Button>

              {/* Projects */}
              <h5 className="mt-3">Projects</h5>
              {cvData.projects.map((proj, index) => (
                <div key={index} className="mb-3">
                  <Form.Group>
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      value={proj.title}
                      onChange={(e) =>
                        handleNestedChange(e, "projects", index, "title")
                      }
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={proj.description}
                      onChange={(e) =>
                        handleNestedChange(e, "projects", index, "description")
                      }
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Technologies</Form.Label>
                    <Form.Control
                      type="text"
                      value={proj.technologies.join(", ")}
                      onChange={(e) => {
                        const updatedTechnologies = e.target.value.split(", ");
                        const updatedProjects = [...cvData.projects];
                        updatedProjects[index] = {
                          ...updatedProjects[index],
                          technologies: updatedTechnologies,
                        };
                        setResume({ ...cvData, projects: updatedProjects });
                      }}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Link</Form.Label>
                    <Form.Control
                      type="text"
                      value={proj.link}
                      onChange={(e) =>
                        handleNestedChange(e, "projects", index, "link")
                      }
                    />
                  </Form.Group>
                  <Button
                    variant="danger"
                    onClick={() => removeEntry("projects", index)}
                  >
                    Remove Project
                  </Button>
                </div>
              ))}
              <Button
                onClick={() =>
                  addEntry("projects", {
                    title: "",
                    description: "",
                    technologies: [],
                    link: "",
                  })
                }
              >
                Add Project
              </Button>

              {/* Skills */}
              <h5 className="mt-3">Skills</h5>
              {cvData.skills.map((skill, index) => (
                <div key={index} className="mb-3">
                  <Form.Control
                    type="text"
                    value={skill}
                    onChange={(e) => {
                      const updatedSkills = [...cvData.skills];
                      updatedSkills[index] = e.target.value;
                      setResume({ ...cvData, skills: updatedSkills });
                    }}
                  />
                  <Button
                    variant="danger"
                    onClick={() => removeEntry("skills", index)}
                  >
                    Remove Skill
                  </Button>
                </div>
              ))}
              <Button onClick={() => addEntry("skills", "")}>
                Add Skill
              </Button>

              {/* Extra Fields */}
              <h5 className="mt-3">Extra Fields</h5>
              <Form.Group className="mb-3">
                <Form.Label>GitHub</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.extraFields.github}
                  onChange={(e) => {
                    const updatedExtraFields = { ...cvData.extraFields, github: e.target.value };
                    setResume({ ...cvData, extraFields: updatedExtraFields });
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>LinkedIn</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.extraFields.linkedin}
                  onChange={(e) => {
                    const updatedExtraFields = { ...cvData.extraFields, linkedin: e.target.value };
                    setResume({ ...cvData, extraFields: updatedExtraFields });
                  }}
                />
              </Form.Group>
            </Card.Body>
          </Card>
        </Col>

        {/* Right Column: Preview Section */}
        <Col xs={12} sm={12} md={6}>
          <div
            ref={componentRef}
            style={{
              padding: "20px",
              border: "1px solid #ddd",
              backgroundColor: "#f9f9f9",
            }}
          >
            <h2>{cvData.name}</h2>
            <h4>{cvData.title}</h4>
            {cvData.photo && (
              <img
                src={cvData.photo}
                alt="Profile"
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  marginBottom: "10px",
                }}
              />
            )}
            <p>{cvData.summary}</p>
            <p>
              {cvData.phoneNumber} | {cvData.email} | {cvData.location}
            </p>

            <h5>Experience</h5>
            {cvData.experience.map((exp, index) => (
              <div key={index}>
                <h6>
                  {exp.title} at {exp.company}
                </h6>
                <p>{exp.startDate} - {exp.endDate}</p>
                <p>{exp.description}</p>
              </div>
            ))}

            <h5>Education</h5>
            {cvData.education.map((edu, index) => (
              <div key={index}>
                <h6>
                  {edu.degree} at {edu.institution}
                </h6>
                <p>{edu.startDate} - {edu.endDate}</p>
              </div>
            ))}

            <h5>Projects</h5>
            {cvData.projects.map((proj, index) => (
              <div key={index}>
                <h6>{proj.title}</h6>
                <p>{proj.description}</p>
                <p>Technologies: {proj.technologies.join(", ")}</p>
                <p>Link: {proj.link}</p>
              </div>
            ))}

            <h5>Skills</h5>
            <ul>
              {cvData.skills.map((skill, index) => (
                <li key={index}>{skill}</li>
              ))}
            </ul>

            <h5>Extra Fields</h5>
            <p>GitHub: {cvData.extraFields.github}</p>
            <p>LinkedIn: {cvData.extraFields.linkedin}</p>

            <Button onClick={handleSaveAsPDF}>Download PDF</Button>
            <Button
              onClick={handleSaveDraft}
              variant="primary"
              className="ms-3"
            >
              Save as Draft
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default EditableResumeTemplate;